"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingList = void 0;
const vue_1 = require("vue");
const complex_utils_1 = require("complex-utils");
const complex_plugin_1 = require("complex-plugin");
const complex_data_1 = require("complex-data");
const litigation_1 = __importDefault(require("@/pages/index/api/litigation"));
const dict_1 = require("@/pages/index/select/dict");
const dictionary_1 = require("@/config/dictionary");
const config_1 = require("@/config/dictionary/config");
const overdue_1 = require("@/pages/index/select/overdue");
const router_1 = __importDefault(require("@/pages/index/router"));
const mainData_1 = __importDefault(require("../../application/mainData"));
class PendingList extends complex_data_1.ComplexList {
    exportData() {
        return new Promise((resolve, reject) => {
            litigation_1.default.litigationContractExport.require(Object.assign(Object.assign({}, this.$getSearch()), { toLitigationStatus: '0' })).then(res => {
                if ((0, complex_utils_1.downloadFile)(res.data.data)) {
                    complex_plugin_1.notice.showMsg('导出成功！');
                }
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
}
exports.PendingList = PendingList;
const pendingList = new PendingList({
    name: '待诉合同',
    prop: 'pendingList',
    module: {
        pagination: true,
        choice: {},
        search: {
            module: {
                dictionary: {
                    layout: {
                        default: {
                            grid: 6,
                            label: 8,
                            content: 16
                        }
                    },
                    list: [
                        (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.business_lines_green, {
                            prop: 'itemname',
                            name: '业务线',
                            originProp: 'itemname',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $target: 'edit'
                                }
                            }
                        }, {
                            onlyLabel: true
                        }),
                        {
                            prop: 'contractNumber',
                            name: '合同号',
                            originProp: 'contractNumber',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input',
                                    option: {
                                        maxLength: 100
                                    }
                                }
                            }
                        },
                        {
                            prop: 'customerName',
                            name: '承租人',
                            originProp: 'customerName',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input',
                                    option: {
                                        maxLength: 100
                                    }
                                }
                            }
                        },
                        (0, dictionary_1.buildDictionaryBySelect)(overdue_1.overdueStatus, {
                            prop: 'overStatus',
                            name: '逾期状态',
                            originProp: 'overStatus',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $target: 'edit'
                                }
                            }
                        }),
                        {
                            prop: 'orgname',
                            name: '经销商',
                            originProp: 'orgname',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input',
                                    option: {
                                        maxLength: 100
                                    }
                                }
                            }
                        },
                    ]
                }
            },
            menu: {
                list: []
            },
        },
        dictionary: {
            layout: {
                default: {
                    grid: 24,
                    label: 8,
                    content: 16
                }
            },
            option: {},
            propData: {
                id: 'id'
            },
            list: [
                {
                    prop: 'id',
                    name: 'ID',
                    originProp: 'id',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'contractId',
                    name: '合同ID',
                    originProp: 'contractId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'projectId',
                    name: '项目ID',
                    originProp: 'projectId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'contractNumber',
                    name: '合同号',
                    originProp: 'contractNumber',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.contractNumber,
                            local: {
                                fixed: 'left'
                            },
                            render(payload) {
                                return (0, vue_1.h)('span', {
                                    class: 'local-main-link',
                                    onClick() {
                                        router_1.default.push(`/overdue/info/${payload.record.id}`);
                                    }
                                }, payload.text);
                            }
                        }
                    }
                },
                {
                    prop: 'itemname',
                    name: '业务线',
                    originProp: 'itemname',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.businessLine
                        }
                    }
                },
                {
                    prop: 'orgCustomerid',
                    name: '经销商ID',
                    originProp: 'orgCustomerid',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'orgname',
                    name: '经销商',
                    originProp: 'orgname',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'areaId',
                    name: '大区ID',
                    originProp: 'areaId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'areaName',
                    name: '大区名称',
                    originProp: 'areaName',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'customerid',
                    name: '承租人ID',
                    originProp: 'customerid',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'customerName',
                    name: '承租人',
                    originProp: 'customerName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        }
                    }
                },
                {
                    prop: 'brandname',
                    name: '车辆品牌',
                    originProp: 'brandname',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: 160
                        }
                    }
                },
                {
                    prop: 'licensePlateNumber',
                    name: '车牌号',
                    originProp: 'licensePlateNumber',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(2, 1, 5)
                        }
                    }
                },
                {
                    prop: 'vinNo',
                    name: '车架号',
                    originProp: 'vinNo',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.vin
                        }
                    }
                },
                {
                    prop: 'engineNo',
                    name: '发动机编号',
                    originProp: 'engineNo',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.vehicleEngineNo
                        }
                    }
                },
                {
                    prop: 'carColour',
                    name: '颜色',
                    originProp: 'carColour',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(4)
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(overdue_1.overdueStatus, {
                    prop: 'overStatus',
                    name: '逾期状态',
                    originProp: 'overStatus',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                }),
                (0, dictionary_1.buildDictionaryBySelect)(overdue_1.vehicleStatus, {
                    prop: 'vehicleStatus',
                    name: '车辆状态',
                    originProp: 'vehicleStatus',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                }),
                {
                    prop: 'maxDay',
                    name: '逾期天数',
                    originProp: 'maxDay',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'numb',
                    name: '逾期期数',
                    originProp: 'numb',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(4)
                        }
                    }
                },
                {
                    prop: 'overdueRank',
                    name: '逾期级别',
                    originProp: 'overdueRank',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(4)
                        }
                    }
                },
                {
                    prop: 'residueRent',
                    name: '剩余租金',
                    originProp: 'residueRent',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'total',
                    name: '逾期总额',
                    originProp: 'total',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'rentOver',
                    name: '逾期租金',
                    originProp: 'rentOver',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'penaltyOver',
                    name: '逾期罚息',
                    originProp: 'penaltyOver',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'remark',
                    name: '备注',
                    originProp: 'remark',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'isDeleted',
                    name: '无',
                    originProp: 'isDeleted',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'enableFlag',
                    name: '无',
                    originProp: 'enableFlag',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'createdBy',
                    name: '创建人id',
                    originProp: 'createdBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'createdTime',
                    name: '创建时间',
                    originProp: 'createdTime',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'updatedBy',
                    name: '更新人',
                    originProp: 'updatedBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'updatedTime',
                    name: '更新时间',
                    originProp: 'updatedTime',
                    originFrom: 'list',
                    mod: {}
                },
            ]
        }
    },
    $getData() {
        return new Promise((resolve, reject) => {
            litigation_1.default.litigationContractList.require(Object.assign(Object.assign({}, this.$getSearch()), { toLitigationStatus: '0', pageNo: this.$getPageData('current'), pageSize: this.$getPageData('size') })).then(res => {
                this.$formatList(res.data.data, res.data.totalCount);
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
});
mainData_1.default.$onLife('buildItem', {
    data() {
        pendingList.$module.choice.reset(true);
        pendingList.$reloadData(true);
    }
});
exports.default = pendingList;
